// Atualização parcial do cadastro da pessoa vinculada ao login autenticado.
//
// Endpoint: PUT /pessoa/:id (whitelist de campos, ignora silenciosamente
// qualquer chave fora dela — ver README da API de Cadastro/Login).

import authApi from '../../../services/authApi';
import logger from '../../../utils/logger';

export const pessoaService = {
  async atualizarDados(pessoaId, dados) {
    try {
      logger.log('📝 Atualizando dados da pessoa...');
      const response = await authApi.put(`/pessoa/${pessoaId}`, dados);
      return response.data;
    } catch (error) {
      logger.error('❌ Erro ao atualizar dados da pessoa:', error);
      throw error;
    }
  },

  // POST /pessoa/juridica — cria (ou reaproveita, se já houver uma PJ em aberto
  // do mesmo usuário com esse nome) a PJ de um pedido de registro de sociedade,
  // só na tabela Pessoa, sem CNPJ e sem login. Ver README da API de Cadastro/Login.
  async criarPessoaJuridica(dados) {
    try {
      logger.log('🏢 Criando pessoa jurídica da sociedade...');
      const response = await authApi.post('/pessoa/juridica', dados);
      return response.data;
    } catch (error) {
      logger.error('❌ Erro ao criar pessoa jurídica da sociedade:', error);
      throw error;
    }
  }
};
